export default __webpack_public_path__ + "static/pixel-vertical-blue-196f7b632e76f10c5f8676604677a487.svg";